// extracted by mini-css-extract-plugin
export default {"columnsContainer":"SnetFooterColumns_columnsContainer__8oVn2","footerColumn":"SnetFooterColumns_footerColumn__My0PM","primary":"SnetFooterColumns_primary__ilLlo"};